import {
  FormControl as FormControlComponent,
  Dialog as DialogComponent,
  DialogContent as DialogContentComponent,
  DialogTitle as DialogTitleComponent,
  Button as ButtonComponent,
} from '@material-ui/core';
import * as lib from '../../dependencies';

export const Container = lib.styled.div`
  width: 350px;
  height: 160px;
  padding: 5px 10px 0 10px;
`;

export const Title = lib.styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const FormControl = lib.styled(FormControlComponent)`
  .MuiInputBase-root {
    height: 42px;
  }
`;

export const Dialog = lib.styled(DialogComponent)`
  .MuiDialog-paper {
    margin: 0;
    padding-bottom: 25px;
  }
`;

export const DialogContent = lib.styled(DialogContentComponent)`
  &.MuiDialogContent-root {
    padding: 0px 0px;
  }
`;

export const DialogTitle = lib.styled(DialogTitleComponent)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  &.MuiDialogTitle-root {
    padding: 20px 15px 9px;
  }

  span {
    font-size: 18px;
    font-weight: 500;
  }
`;

export const Button = lib.styled(ButtonComponent)`
  &.MuiButton-root:hover {
    background-color: inherit;
  }
`;
